import {
  Button,
  Card,
  Divider,
  Grid,
  Icon,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Tabs,
} from '@mui/material';
import DataView from 'app/views/DataView/DataView';
import React, { useEffect, useState } from 'react';
import Api, { apiPaths } from '../../../services/api';
import { getFormModAndID } from '../../smart-kit/Form/gridFormUtils';
import { storeFields } from './StoreForm';

const StoreView = (props) => {
  return <DataView apipath={apiPaths.STORES} columns={storeFields} />;
};

export default StoreView;
